import { getBranchBankList, getCoopBankList } from '@/api/bank'

const state = {
  // 整页选择器的数据列表
  branchBankList: [],
  coopBankList: []
}
const mutations = {
  // 设置整页选择器的数据列表
  SET_BRANCH_BANK_LIST (state, list) {
    state.branchBankList = list
  },
  SET_COOP_BANK_LIST (state, list) {
    state.coopBankList = list
  }
}

const actions = {
  // 使用银行 ID  获取银行分行列表
  async getBranchBankList ({ commit }, params) {
    const response = await getBranchBankList(params)
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_BRANCH_BANK_LIST', data)
    } else {
      commit('SET_BRANCH_BANK_LIST', [])
    }
    return response.data
  },

  async getCoopBankList({ commit }) {
    const response = await getCoopBankList()
    const { code, data } = response.data
    if (code === 0) {
      commit('SET_COOP_BANK_LIST', data)
    } else {
      commit('SET_COOP_BANK_LIST', [])
    }
    return response
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
